const ViewsFactory = require('public_framework/views_factory')

const Components = {
  SurveyReport: {
    Content: require('public_shared_components/content_menu_tracker')
  },
  Shared: {
    Chart: require('public_shared_components/chart'),
    SocialShare: require('public_shared_components/social_share')
  },
  Ui: {
    Slider: require('public_shared_components/ui/slider/views/slider')
  }
}

ViewsFactory.addComponents(Components)



// WEBPACK FOOTER //
// ./front/apps/public/pages/ultimate_freelancer_guide/javascripts/index.js